import Keycloak from "keycloak-js";
import KeycloakConfig from "@/constants/Keycloak";
import Vue from "vue";

const _kc = new Keycloak(KeycloakConfig);

const initKeycloak = onAuthenticatedCallback => {
  //router link when user clicks browser notification
  const path = window.location.pathname;
  const key = "redirect-landing-page/";
  if (path.includes(key)) {
    let targetURL = path.split(key)[1];
    window.location.href = targetURL;
    return;
  }

  let loader = Vue.$loading.show({
    // Optional parameters
    container: null,
    canCancel: false,
    color: "#00bcd4",
    zIndex: 9,
    enforceFocus: false
  });

  _kc
    .init({
      onLoad: KeycloakConfig.onLoad
    })
    .then(authenticated => {
      if (authenticated) {
        onAuthenticatedCallback && onAuthenticatedCallback();
        initUpdateTokenInterval();
      } else {
        doLogin();
      }
    })
    .finally(() => {
      loader.hide();
    });
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateTokenOnRequest = successCallback =>
  _kc
    .updateToken(70)
    .then(successCallback)
    .catch(doLogin);

const initUpdateTokenInterval = () =>
  setInterval(async () => {
    try {
      const refreshed = await _kc.updateToken(70);

      // if (refreshed) {
      //   Vue.$log.info("Token refreshed" + refreshed);
      //   return;
      // }

      // Vue.$log.warn(
      //   "Token not refreshed, valid for " +
      //     Math.round(
      //       _kc.tokenParsed.exp +
      //         _kc.timeSkew -
      //         new Date().getTime() / 1000
      //     ) +
      //     " seconds"
      // );
    } catch (error) {
      // Vue.$log.error("Failed to refresh token");
    }
  }, 6000);

const getUser = () => _kc.tokenParsed;

const hasRole = roles => roles.some(role => _kc.hasRealmRole(role));

const KeycloakLib = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateTokenOnRequest,
  getUser,
  hasRole
};

export default KeycloakLib;
